class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

// Guard mobile drawer search forms: only navigate when predictive search returns results
document.addEventListener('DOMContentLoaded', function () {
  const drawerForms = document.querySelectorAll('form.search--drawer');
  if (!drawerForms.length) return;

  drawerForms.forEach((form) => {
    form.addEventListener('submit', function (e) {
      // allow programmatic submissions to pass through
      if (form.__drawerSubmitting) {
        form.__drawerSubmitting = false;
        return;
      }
      const input = form.querySelector('input[name="q"]');
      const query = input ? input.value.trim() : '';

      // empty query -> prevent submit
      if (!query) {
        e.preventDefault();
        return;
      }

      // prevent default while we check server-side predictive results
      e.preventDefault();

      // use timeout to avoid hanging forever
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 3000);

      fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(query)}&section_id=predictive-search`, {
        signal: controller.signal,
      })
        .then((resp) => {
          clearTimeout(timeoutId);
          if (!resp.ok) {
            // fallback: submit the form normally to let server handle it
            form.submit();
            return Promise.reject(new Error('network'));
          }
          return resp.text();
        })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const countEl = doc.querySelector('[data-predictive-search-live-region-count-value]');
          const count = countEl ? parseInt((countEl.textContent || '').replace(/[^0-9]/g, ''), 10) : 0;

          if (count > 0) {
            // Close the drawer to avoid overlay/frame issues before navigation
            try {
              const drawerDetails = document.getElementById('Details-menu-drawer-container');
              if (drawerDetails && drawerDetails.open) drawerDetails.open = false;
            } catch (e) {
              // ignore
            }

            // Close any modal overlays and navigate after a short delay to avoid renderer crashes
            try {
              const overlay = document.querySelector('.modal-overlay');
              if (overlay) overlay.remove();
            } catch (e) {
              // ignore
            }

            try {
              const drawerDetails = document.getElementById('Details-menu-drawer-container');
              if (drawerDetails && drawerDetails.open) drawerDetails.open = false;
            } catch (e) {
              // ignore
            }

            // small delay to let UI settle (close animations, overlays)
            setTimeout(() => {
              try {
                // navigate using location assign to ensure a fresh navigation context
                window.location.href = form.action + '?q=' + encodeURIComponent(query);
              } catch (err) {
                // fallback: try form.submit
                try {
                  form.__drawerSubmitting = true;
                  form.submit();
                } catch (err2) {
                  // ignore
                }
              }
            }, 220);
            return;
          } else {
            // no results — keep user on drawer, give light feedback
            input.focus();
            form.classList.add('search--no-results');
            setTimeout(() => form.classList.remove('search--no-results'), 1500);
          }
        })
        .catch((err) => {
          clearTimeout(timeoutId);
          // on fetch abort or error, fallback to normal submit so search still works
          try {
            form.submit();
          } catch (submitErr) {
            // ignore
          }
        });
    });
  });
});

// Reset drawer search inputs each time the drawer is opened to avoid persisting previous queries
try {
  const drawerDetails = document.getElementById('Details-menu-drawer-container');
  if (drawerDetails) {
    drawerDetails.addEventListener('toggle', function () {
      if (!drawerDetails.open) return; // only reset when opened
      const forms = drawerDetails.querySelectorAll('form.search--drawer');
      forms.forEach((f) => {
        try {
          const input = f.querySelector('input[name="q"]');
          if (input) {
            input.value = '';
            // trigger input handlers (toggle reset button etc.)
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }

          // remove no-results state, CTA and any predictive results
          f.classList.remove('search--no-results');
          const cta = f.querySelector('.drawer-search-open-results');
          if (cta) cta.remove();
          const predictive = f.querySelector('[data-predictive-search]');
          if (predictive) predictive.innerHTML = '';
          // clear any programmatic submit flag
          f.__drawerSubmitting = false;
        } catch (e) {
          // defensive - swallow errors
        }
      });
    });
  }
} catch (e) {
  // ignore
}

